module.exports = __webpack_public_path__ + "static/img/team1.f774ded5.svg";